import { memo } from 'react';
import { Button } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import clsx from 'clsx';

import { useStyles } from './style';

interface Props {
  background?: string;
  onClick?: () => void;
  dir?: 'up' | 'down' | 'left' | 'right';
}

const ToggleButton: React.FC<Props> = ({
  dir = 'down',
  background = '#F0F3F7',
  onClick,
}) => {
  const cssProps = { backgroundColor: background };
  const classes = useStyles(cssProps);

  return (
    <Button
      onClick={onClick}
      classes={{
        root: classes.root,
      }}
    >
      <KeyboardArrowDownIcon
        className={clsx(classes.icon, {
          [classes.down]: dir === 'down',
          [classes.up]: dir === 'up',
          [classes.left]: dir === 'left',
          [classes.right]: dir === 'right',
        })}
      />
    </Button>
  );
};

export default memo(ToggleButton);
